import { faThumbTack } from '@fortawesome/pro-light-svg-icons';
import { faThumbTack as solidTack } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useGetPinnedQuery, useSetPinnedMutation } from 'API/order/PinnedAndRecentAPI';
import React from 'react';
import { toast } from 'react-toastify';
import { Button } from 'ui-toolkit';

export interface IPinOrderProps {
  fileNumber: string | null;
}

export const PinOrder: React.FC<IPinOrderProps> = ({ fileNumber }) => {
  const { data: orders = [] } = useGetPinnedQuery(undefined, { pollingInterval: 300 });
  const [setOrders] = useSetPinnedMutation();

  const isPinned = fileNumber && orders.includes(fileNumber);

  const onPinOrder = () => {
    if (orders.length >= 10) {
      toast('You can only have 10 pinned orders, please unpin one to pin this one', { type: 'error' });
    } else {
      fileNumber && setOrders(orders.concat(fileNumber));
      toast('This order is now pinned');
    }
  };
  const onUnpinOrder = () => {
    setOrders(orders.filter((t) => t !== fileNumber));
    toast('This order has now unpinned');
  };

  return (
    <>
      {!isPinned && (
        <Button intent={'ghost'} isInline onClick={onPinOrder} data-test-id={'Pin-Order'}>
          <FontAwesomeIcon icon={faThumbTack} size={'xl'} />
        </Button>
      )}
      {isPinned && (
        <Button intent={'ghost'} isInline onClick={onUnpinOrder} data-test-id={'Unpin-Order'}>
          <FontAwesomeIcon icon={solidTack} size={'xl'} />
        </Button>
      )}
    </>
  );
};
